import * as React from "react";
import Panel from "../Panel";
import RegisterForm from "../components/User/RegisterForm";
import { ErrorBoundary } from "react-error-boundary";
import SunsureErrorFallback from "../utils/SunsureErrorFallback";

export default function CreateNewAccount() {
  return (
    <>
      <ErrorBoundary fallback={<SunsureErrorFallback />}>
        <Panel maxWidth={480}>
          <RegisterForm />
        </Panel>
      </ErrorBoundary>
    </>
  );
}
